export default __webpack_public_path__ + "static/media/failPay.506c59e8.svg";